import React, { useState, useEffect } from "react";
import Loading from "../../../../Student/Reusablecomponents/Loading";
import ScenarioQuestionformat from "../../../../Student/Reusablecomponents/ScenarioQuestionformat";

import { HiMiniPlusSmall } from "react-icons/hi2";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import DataTable from "../../../../Student/Reusablecomponents/DataTable/DataTable";
import { RiDeleteBin5Line } from "react-icons/ri";
import { FaRegEye } from "react-icons/fa";
import { QuestionData } from "../../../../Redux/Reducers/QBAdmin/EditQuestions";
import {
  ViewVerificationQStatus,
  QuestionDelete,
  // GetQuestionDetails,
  // GetScienceQuestionDetails,
  QuestionPreview,
  ViewQuestionStatus,
} from "../../../../ReusableComponents/CommonApis";
import {
  GetEnglishScenarioDetails,
  GetEnglishQuestionDetails,
} from "../../../../ReusableComponents/CommonApis";
import { FaClockRotateLeft } from "react-icons/fa6";
const ScenarioEnglishQuestions = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const Scenario = useSelector(
    (state) => state.ScenarioDeatils.ScenarioDetails
  );
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );

  const [Load, SetLoad] = useState(false);
  const [QuestionList, SetQuestionList] = useState();
  const [StatusData, SetStatusData] = useState();
  const [QuestionsData, SetQuestionData] = useState();
  const [DMessage, SetDMessage] = useState();

  useEffect(() => {
    if (Scenario?.scenarioID) {
      QuestionsByScenarioId();
    }
  }, [DMessage]);

  const QuestionsByScenarioId = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBank/GetLanguageQuestionsByScenarioId?ScenarioID=${Scenario?.scenarioID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0]?.questionID) {
          SetQuestionList(res.data);
        } else {
          SetQuestionList(process.env.REACT_APP_NODATAFOUND);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const HandleQuestionDetails = (Qid) => {
    GetEnglishQuestionDetails(Qid, dispatch, navigate, SetLoad, location);
    // if(items.subjectId === "1"){
    //     GetQuestionDetails(SelectLanguage,Qid, dispatch, navigate, SetLoad, location);
    // }else{
    //     GetScienceQuestionDetails(SelectLanguage,Qid, dispatch, navigate, SetLoad, location);
    // }
  };
  const columns = [
    {
      name: "Question No(Id)",
      selector: "questionID",
      sortable: true,
      cell: (row) => (
        <div
          className="LinkStyles"
          title="Edit Question"
          onClick={() => HandleQuestionDetails(row.questionID)}
        >
          {row.questionID}{" "}
        </div>
      ),
    },
    {
      name: "Question",
      selector: "question",
      cell: (row) => (
        <div className="ScenarioList">
          <ScenarioQuestionformat scenario={row.question} />
          {row.qType === "M" &&
            ["A", "B", "C", "D"].map((option, i) => (
               <>
               {row?.[`option${option}`] && 
              <div
                key={i}
                className="Options"
                style={
                  option === row.answer
                    ? { color: "green", fontWeight: "bold" }
                    : {}
                }
              >
                <span className="dflex p-1">
                  {option})&nbsp;{" "}
                  <ScenarioQuestionformat scenario={row[`option${option}`]} />{" "}
                </span>
              </div>}</>
            ))}
        </div>
      ),
    },
    {
      name: "Answer(s)",
      selector: "option",
      sortable: true,
      cell: (row) => (
        <div className="dflex">
          {row.qType === "D" ? (
            <ScenarioQuestionformat scenario={row.answer} />
          ) : (
            <span className="dflex p-1">
              {row.answer}) &nbsp;
              <ScenarioQuestionformat
                scenario={row[`option${row.answer}`]}
              />{" "}
            </span>
          )}
        </div>
      ),
    },
    ...(items?.subjectId === "1"
      ? [
          {
            name: "Clone / Original",
            selector: "isClonedOrOriginal",
            sortable: true,
          },
        ]
      : []),
    {
      name: "Question Verification Status",
      selector: "qVerificationStatus",
      sortable: true,
      cell: (row) => (
        <div className="dflex flexd-column">
          <span>{row.qVerificationStatus}</span>
          <span
            className="LinkStyles"
            onClick={() => {
              SetStatusData(row.questionID);
            }}
          >
            {" "}
            View Status Log{" "}
          </span>
        </div>
      ),
    },
    {
      name: "Used/Unused - Mapped/UnMapped",
      selector: "isUsed",
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div
          className="dflex CPointer"
          style={{ gap: "15px", justifyContent: "center" }}
        >
          <FaRegEye
            title="Preview"
            onClick={() => QuestionPreview(row, dispatch, navigate, location)}
          />
          <RiDeleteBin5Line
            title="Delete"
            style={{ color: "#FD3333" }}
            onClick={() => {
              SetDMessage();
              QuestionDelete(row.questionID, SetDMessage, dispatch, location);
            }}
          />{" "}
          <span
            className="LinkStyles"
            style={{ textWrap: "nowrap" }}
            onClick={() => SetQuestionData(row.questionID)}
            title="View Question Activity Log"
          >
            <FaClockRotateLeft />
          </span>
        </div>
      ),
    },
  ];

  const NAUQuestions = () => {
    GetEnglishScenarioDetails(
      Scenario.scenarioID ,
      dispatch,
      navigate,
      SetLoad,
      location,
      false
    );
    dispatch(QuestionData({ QuestionDetails: "" }));
    // || location.state?.SID
    //  navigate("/QBAdmin/QuestionBank/AddUpdateQuestions", { state: { Tab: location.state?.Tab , SID: location.state?.SID, SName: location.state?.SName } });
    /*dispatch(ScenarioData({ ScenarioDetails: "" }));*/
  };
  return (
    <>
      <div className="MainHeading">Questions</div>
      <div className="Card ">
        <div className="SubHeading mb-2"> Scenario (Id - {Scenario?.scenarioID}) </div>
        <ScenarioQuestionformat scenario={Scenario?.scenarioName} />
      </div>

      <div className="dflex mt-3 mb-2 alignitems JSBetween">
        <div className="SubHeading">Question bank</div>
        <button
          className="Buttons AddButton"
          onClick={() => {
            NAUQuestions();
          }}
        >
          <HiMiniPlusSmall /> Add Question
        </button>
      </div>

      <div className="Card">
        {QuestionList?.[0]?.questionID ? (
          <DataTable
            className="NCLDataTable"
            data={QuestionList}
            columns={columns}
          />
        ) : (
          <div className="ErrorMessage">{QuestionList}</div>
        )}
      </div>
      {StatusData && (
        <ViewVerificationQStatus QId={StatusData} Close={SetStatusData} />
      )}
      {QuestionsData && (
        <ViewQuestionStatus QId={QuestionsData} Close={SetQuestionData} />
      )}

      {DMessage?.open && (
        <div className="Model-Open">
          <div className="Card w-50">
            {" "}
            {DMessage?.message}
            <button
              className="Buttons bg-danger"
              style={{ float: "right" }}
              onClick={() => {
                SetDMessage({ open: false });
              }}
            >
              cancel
            </button>
          </div>
        </div>
      )}
      {Load && <Loading />}
    </>
  );
};
export default ScenarioEnglishQuestions;
